var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.detalle
      ? _c(
          "div",
          { staticClass: "ibox sombra-light" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "ibox-content" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.getreporte.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.buttonDisable, rounded: "sm" } },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Fecha de inicio")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "b-form-datepicker",
                                  _vm._b(
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        id: "fechaInicioGrafico",
                                        placeholder: "Fecha de inicio",
                                        locale: _vm.datepicker.idioma,
                                      },
                                      model: {
                                        value: _vm.form.fechaInicio,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "fechaInicio", $$v)
                                        },
                                        expression: "form.fechaInicio",
                                      },
                                    },
                                    "b-form-datepicker",
                                    _vm.datepicker.etiquetas[
                                      _vm.datepicker.idioma
                                    ] || {},
                                    false
                                  )
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Fecha de término")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-group" },
                              [
                                _c(
                                  "b-form-datepicker",
                                  _vm._b(
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        id: "fechaTerminoGrafico",
                                        placeholder: "Fecha de término",
                                        locale: _vm.datepicker.idioma,
                                      },
                                      model: {
                                        value: _vm.form.fechaTermino,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "fechaTermino",
                                            $$v
                                          )
                                        },
                                        expression: "form.fechaTermino",
                                      },
                                    },
                                    "b-form-datepicker",
                                    _vm.datepicker.etiquetas[
                                      _vm.datepicker.idioma
                                    ] || {},
                                    false
                                  )
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Estado")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.id_estado,
                                      expression: "form.id_estado",
                                    },
                                  ],
                                  staticClass: "custom-select custom-select-sm",
                                  staticStyle: {
                                    width: "200px",
                                    height: "35px",
                                  },
                                  attrs: { name: "type" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form,
                                        "id_estado",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "Todos" } }, [
                                    _vm._v("Todos"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.estados, function (item, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: item.id },
                                      },
                                      [_vm._v(_vm._s(item.nombre))]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "offset-md-6 col-md-6" },
                          [
                            _c(
                              "b-button",
                              {
                                class: `buscar-info-dashboard`,
                                attrs: {
                                  block: "",
                                  variant: "primary",
                                  type: "submit",
                                  disabled: _vm.buttonDisable,
                                },
                                on: { submit: _vm.getreporte },
                              },
                              [_vm._v("Buscar")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _c("div", { staticClass: "graficos" }, [
                _c("div", { staticClass: "ibox sombra-light" }, [
                  _c(
                    "div",
                    { staticClass: "ibox-content" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("data-table", {
                                attrs: {
                                  id: _vm.dt.id,
                                  datos: _vm.dt.datos,
                                  columnas: _vm.dt.columnas,
                                  responsive: true,
                                  "font-size": 12,
                                },
                                on: { test: _vm.test },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "detalles",
                                      fn: function (item) {
                                        return [
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-primary",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.test(
                                                      item.data.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ver")]
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2724681168
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ],
          1
        )
      : _c("div", { staticClass: "ibox sombra-light" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group pull-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-xs btn-primary",
                  on: {
                    click: function ($event) {
                      return _vm.volver()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-arrow-circle-left" }),
                  _vm._v(" Volver\r\n                "),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-3" }, [_vm._v("Proveedor")]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [_vm._v("Metodo")]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [_vm._v("Codigo")]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [_vm._v("Estado")]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [_vm._v("Fecha")]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _vm._v(
                  _vm._s(_vm.error.auditoria_integracion.proveedor.nombre)
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _vm._v(
                  _vm._s(_vm.error.auditoria_integracion.parametro.metodo)
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [
                _vm._v(
                  _vm._s(_vm.error.auditoria_integracion.id_codigo_integracion)
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [
                _vm._v(_vm._s(_vm.error.estado.nombre)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [
                _vm._v(_vm._s(_vm.error.auditoria_integracion.created_at)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-md-6" },
                [
                  _vm._v("\r\n                    Request "),
                  _c("br"),
                  _vm._v(" "),
                  _c("vue-json-pretty", {
                    attrs: {
                      data: _vm.getValue(
                        _vm.error.auditoria_integracion.request
                      ),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-12 col-md-6" },
                [
                  _vm._v("\r\n                    Response "),
                  _c("br"),
                  _vm._v(" "),
                  _c("vue-json-pretty", {
                    attrs: {
                      data: _vm.getValue(
                        _vm.error.auditoria_integracion.response
                      ),
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Comentario")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.comentario,
                          expression: "comentario",
                        },
                      ],
                      staticClass: "mb-2",
                      attrs: { rows: "5", cols: "40" },
                      domProps: { value: _vm.comentario },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.comentario = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Estado")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.id_estado,
                            expression: "id_estado",
                          },
                        ],
                        staticClass: "custom-select custom-select-sm",
                        staticStyle: { width: "200px", height: "35px" },
                        attrs: { name: "type" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.id_estado = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.estado_disponibles, function (item, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: item.id } },
                          [_vm._v(_vm._s(item.nombre))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "offset-md-6 col-md-6" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "buscar-info-dashboard",
                      attrs: { block: "", variant: "primary" },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-chart-bar" }),
        _vm._v(" Errores Integraciones\r\n            "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-bar" }),
      _vm._v(" Detalles\r\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }